import React from 'react';
import { useTranslation } from 'react-i18next';
import usePrecheckPOS from '../../hooks/usePrecheckPOS';
import SinglePrecheckView from '../shared/SinglePrecheckView';

const SinglePrecheckPos: React.FC = () => {
  const { t } = useTranslation();
  const { precheckPos, loading, error } = usePrecheckPOS();

  const getTitle = (data: typeof precheckPos) => {
    return `${t('prechecksPOS.title')} ${t('common.for')} ${data?.company}`;
  };

  const renderContent = (data: NonNullable<typeof precheckPos>) => (
    <table className="table-auto w-full text-sm my-2">
      <tbody>
        <tr>
          <td className="border px-4 py-2">{t('merchant.company')}</td>
          <td className="border px-4 py-2 lowercase">{data.company}</td>
        </tr>
        <tr>
          <td className="border px-4 py-2">{t('merchant.taxId')}</td>
          <td className="border px-4 py-2 lowercase">{data.taxId}</td>
        </tr>
        <tr>
          <td className="border px-4 py-2">{t('merchant.creditorId')}</td>
          <td className="border px-4 py-2 lowercase">{data.creditorId}</td>
        </tr>
        <tr>
          <td className="border px-4 py-2">{t('merchant.industry')}</td>
          <td className="border px-4 py-2 lowercase">{data.industry}</td>
        </tr>
        <tr>
          <td className="border px-4 py-2">{t('merchant.address')}</td>
          <td className="border px-4 py-2 lowercase">{data.address}</td>
        </tr>
        <tr>
          <td className="border px-4 py-2">{t('merchant.locations')}</td>
          <td className="border px-4 py-2 lowercase">{data.locations}</td>
        </tr>
        <tr>
          <td className="border px-4 py-2">{t('merchant.website')}</td>
          <td className="border px-4 py-2 lowercase">
            <a href={data.website} target="_blank" rel="noopener noreferrer">
              {data.website}
            </a>
          </td>
        </tr>
        <tr>
          <td className="border px-4 py-2">{t('merchant.director')}</td>
          <td className="border px-4 py-2 lowercase">{data.director}</td>
        </tr>
        <tr>
          <td className="border px-4 py-2">{t('merchant.contactPerson')}</td>
          <td className="border px-4 py-2 lowercase">{data.contactPerson}</td>
        </tr>
        <tr>
          <td className="border px-4 py-2">{t('merchant.email')}</td>
          <td className="border px-4 py-2 lowercase">
            <a href={`mailto:${data.email}`}>{data.email}</a>
          </td>
        </tr>
        <tr>
          <td className="border px-4 py-2">{t('merchant.telephone')}</td>
          <td className="border px-4 py-2 lowercase">{data.telephone}</td>
        </tr>
        <tr>
          <td className="border px-4 py-2">{t('merchant.mobile')}</td>
          <td className="border px-4 py-2 lowercase">{data.mobile}</td>
        </tr>
        <tr>
          <td className="border px-4 py-2">{t('merchant.currentProvider')}</td>
          <td className="border px-4 py-2 lowercase">{data.currentProvider}</td>
        </tr>
        <tr>
          <td className="border px-4 py-2">{t('merchant.turnover')}</td>
          <td className="border px-4 py-2 lowercase">{data.turnover}</td>
        </tr>
        <tr>
          <td className="border px-4 py-2">{t('merchant.receiptSize')}</td>
          <td className="border px-4 py-2 lowercase">{data.receiptSize}</td>
        </tr>
        <tr>
          <td className="border px-4 py-2">{t('merchant.bankStatementReference')}</td>
          <td className="border px-4 py-2 lowercase">{data.bankStatementReference}</td>
        </tr>
        <tr>
          <td className="border px-4 py-2">{t('merchant.terminals')}</td>
          <td className="border px-4 py-2 lowercase">{data.terminals}</td>
        </tr>
        <tr>
          <td className="border px-4 py-2">{t('merchant.checkoutConnection')}</td>
          <td className="border px-4 py-2 lowercase">{data.checkoutConnection}</td>
        </tr>
        <tr>
          <td className="border px-4 py-2">{t('merchant.cashCut')}</td>
          <td className="border px-4 py-2 lowercase">{data.cashCut}</td>
        </tr>
        <tr>
          <td className="border px-4 py-2">{t('merchant.tip')}</td>
          <td className="border px-4 py-2 lowercase">{data.tip}</td>
        </tr>
        <tr>
          <td className="border px-4 py-2">{t('merchant.cards')}</td>
          <td className="border px-4 py-2 lowercase">{data.cards.join(', ')}</td>
        </tr>
        <tr>
          <td className="border px-4 py-2">{t('merchant.additionalServices')}</td>
          <td className="border px-4 py-2 lowercase">{data.additionalServices.join(', ')}</td>
        </tr>
        <tr>
          <td className="border px-4 py-2">{t('common.createdAt')}</td>
          <td className="border px-4 py-2 lowercase">{new Date(data.createdAt).toLocaleDateString()}</td>
        </tr>
      </tbody>
    </table>
  );

  return (
    <SinglePrecheckView
      type="precheck-pos"
      data={precheckPos}
      loading={loading}
      error={error}
      getTitle={getTitle}
      renderContent={renderContent}
    />
  );
};

export default SinglePrecheckPos;
